import axios from 'axios';
import { Dispatch } from 'redux';
import {
  NpcStorageActionTypes,
  NpcStorageAction,
} from '../../types/npcStorage';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';
import { npcTypes } from '../../utils/constants';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};
const storageExpenses = [
  npcTypes.fbaStorage.value,
  npcTypes.fbaLongStorage.value,
  npcTypes.fbaShortStorage.value,
];

const CancelToken = axios.CancelToken;
let cancelStorage: any = null;
let cancelStorageBrand: any = null;

export const getNpcStorage =
  (data: any) => async (dispatch: Dispatch<NpcStorageAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcStorageActionTypes.SET_NPC_STORAGE_LOADING,
      });

      if (cancelStorage) {
        cancelStorage();
        cancelStorage = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelStorage = c;
        }),
      };

      const res = await axios.post('/api/npcreports/storage', body, config2);
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE,
        payload: {},
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType: NpcStorageActionTypes.SET_NPC_STORAGE_LOADING,
      });
    }
  };

export const getNpcStorageBrand =
  (data: any) => async (dispatch: Dispatch<NpcStorageAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcStorageActionTypes.SET_NPC_STORAGE_BRAND_LOADING,
      });

      if (cancelStorageBrand) {
        cancelStorageBrand();
        cancelStorageBrand = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelStorageBrand = c;
        }),
      };

      const res = await axios.post(
        '/api/npcreports/storage/brand',
        body,
        config2
      );
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_BRAND,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_BRAND,
        payload: {},
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType: NpcStorageActionTypes.SET_NPC_STORAGE_BRAND_LOADING,
      });
    }
  };

export const getNpcStorageParams =
  () => async (dispatch: Dispatch<NpcStorageAction | any>) => {
    const body = JSON.stringify({ types: storageExpenses }); //
    try {
      const res = await axios.post('/api/npc/params', body, config);
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_PARAMS,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_PARAMS,
        payload: {},
      });
    }
  };

export const getNpcStorageMinDate =
  () => async (dispatch: Dispatch<NpcStorageAction | any>) => {
    const body = JSON.stringify({ types: storageExpenses });
    try {
      const res = await axios.post('/api/npc/mindate', body, config);
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_MINDATE,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcStorageActionTypes.GET_NPC_STORAGE_MINDATE,
        payload: '',
      });
    }
  };

export const clearNpcStorage =
  () => async (dispatch: Dispatch<NpcStorageAction>) => {
    dispatch({
      type: NpcStorageActionTypes.CLEAR_NPC_STORAGE,
    });
  };
